import { getZooId } from "../../tools/conf";
import { UserDatabaseConnector } from "../../dataconnector/usersDatabaseConnector";

/**
 * Scope zoo courant pour les requêtes Firestore de LISTE sur la collection
 * racine `animals` (pendant web du module WellfareMonitor2
 * app/utils/firestore/zooScope.js).
 *
 * Les security rules `animals` durcies (revertées par PR #294 suite à
 * l'incident du 28-31/08/2026, re-durcissement prévu — cf.
 * docs/decisions/2026-08-31-revert-animals-rules-hardening.md) conditionnent
 * la lecture à `resource.data.zooId == getUserData().zooId`. Or les rules ne
 * filtrent pas : une requête de LISTE qui ne garantit pas structurellement ce
 * prédicat (pas de .where("zooId", "==", zooId)) est refusée EN BLOC
 * (permission-denied), même si tous ses résultats auraient été autorisés
 * (« rules are not filters »). Les gets par ID de document ne sont pas
 * concernés.
 *
 * Toute requête .where(...) sur `animals` doit donc passer par ce scope :
 * - cas courant : `const { zooId } = await getAnimalsQueryScope()` puis
 *   préfixer la requête par `.where("zooId", "==", zooId)` ;
 * - flux cross-zoo staff (référentiel espèces, dashboards AKONGO) :
 *   brancher sur canReadAllZoos pour ne scoper que les non-staff.
 *
 * Le zooId vient de getZooId() (qui suit le switch de zoo staff) avec
 * fallback sur le document utilisateur — même résolution que
 * AnimalDatabaseConnector._getAnimalQueryScope, dont ce module est
 * l'extraction mutualisée.
 */

let uConnect = null;
const userConnector = () => {
  if (!uConnect) {
    uConnect = new UserDatabaseConnector();
  }
  return uConnect;
};

export const ANIMAL_QUERY_ZOO_REQUIRED = "ANIMAL_QUERY_ZOO_REQUIRED";

export async function getAnimalsQueryScope() {
  let userData = null;
  try {
    const user = await userConnector()._getUserData();
    userData = user?.data || null;
  } catch (_) {
    // getZooId remains the canonical fallback for legacy authenticated views.
  }
  const configuredZooId = await getZooId();
  const zooId = configuredZooId || userData?.zooId || userData?.userZoo?.value;
  if (typeof zooId !== "string" || !zooId.trim()) {
    throw new Error(ANIMAL_QUERY_ZOO_REQUIRED);
  }
  return {
    canReadAllZoos: userData?.akongoStaff === true,
    zooId: zooId.trim(),
  };
}
